// 47263b (K-S3) — the ONE page-frame geometry used to pin the header/footer to each physical page on the document sheet
// (DocumentSheet) and the Settings preview. Kept here, pure and testable, so the footer-pin geometry has a single source a
// real-browser test can enforce (see docFramePin.browser.test.mjs). mm, not px, so A4 (297mm) a short doc fills a whole page.
export const PX_PER_MM = 96 / 25.4;
// the header/footer baseline sits this far inside the page margin (matches the server PDF's ~5-6mm bottom inset, 47169)
export const FRAME_INSET_MM = 5.29;

// whole pages: the measured body height (px) over one page's content height (mm). Always >= 1, so a short document is one full page.
export const framePages = (contentPx, contentHmm) => Math.max(1, Math.ceil(contentPx / (Math.max(1, contentHmm) * PX_PER_MM) - 0.002));

// absolute position of a header/footer piece on page i (0-based) of `pages`, on a sheet whose min-height is pages * pageHmm.
// header: inset below page i's top; footer: inset above page i's bottom — so every page carries both, at the page edge.
export const framePieceStyle = (part, i, pages, pageHmm) => (part === 'header'
  ? { top: `${i * pageHmm + FRAME_INSET_MM}mm` }
  : { bottom: `${(pages - 1 - i) * pageHmm + FRAME_INSET_MM}mm` });

// fill the PDF header/footer template's {page}/{pages} placeholder spans per page (the server PDF counters, drawn live on screen)
export const counters = (html, n, total) => String(html || '')
  .replace(/<span class="pageNumber"><\/span>/g, String(n))
  .replace(/<span class="totalPages"><\/span>/g, String(total));
